<template>
  <div class="home">
    <img  src="../assets/APP_banner.jpg" class="home-banner" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {
  }
};
</script>

<style lang='css'>
.home{
  background-color: #53574D !important;
  height:860px;
}
.home-banner {
  width:auto;
}
</style>
